import { Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material"
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useState } from "react";
import { useDispatch } from "react-redux";
import { handleQuestion } from "./surveySlice";
import { makeStyles } from "@mui/styles";

const centerAlignStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'flex-start',
}

const useStyles = makeStyles((theme) => ({
  radioStyle: {
    "& .MuiTypography-root": {
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '37px',
      color: '#CFCFCF',
    },
    "& .MuiRadio-root": {
      color: '#56CCF2',
    },
    "& svg": {
      width: "48px",
      height: "48px"
    }
  },
  typographyStyle: {
    fontWeight: 500,
    fontSize: '28px',
    lineHeight: '45px',
    marginBottom: '40px',
  }
}));

export const SurveyQuestions = ({ handleNext, index, data, handleSubmit }: any) => {

  const [value, setValue] = useState('');
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(handleQuestion((event.target as HTMLInputElement).value));
    setValue((event.target as HTMLInputElement).value);
  };

  return (
    <Grid item xs={12}>
      <form onSubmit={handleSubmit}>
        <Grid container sx={{ width: '70%', margin: '0 auto' }}>
          <Grid item xs={12} sx={{ ...centerAlignStyle }}>
            <Typography color='primary' className={classes.typographyStyle} id="demo-radio-buttons-group-label">
              {data?.question}
            </Typography>
            <FormControl>
              <RadioGroup
                aria-labelledby="survey-options"
                value={value}
                name={data.name}
                onChange={(handleRadioChange)}
              >
                {
                  data.options.map((item: any) => {
                    return <FormControlLabel key={item.value} value={item.value.toString()} className={classes.radioStyle} control={<Radio color='secondary' />} label={item.option} />
                  })
                }
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ marginTop: '50px' }}>
            {data.questionId === 4 ? (
              <Button type="submit" sx={{ borderRadius: '3rem', textTransform: 'capitalize', padding: '0.625rem 1.25rem' }} variant="contained" endIcon={<ArrowForwardIcon />} >Submit</Button>
            ) : (
              <Button onClick={() => handleNext(index, data.questionId,)} sx={{ borderRadius: '3rem', textTransform: 'capitalize', padding: '0.625rem 1.25rem' }} variant="contained" endIcon={<ArrowForwardIcon />} >Next</Button>
            )}
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
} 